import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { DevExpressModule } from '../../devexpress.module';
import { SharedModule } from '../../shared/shared.module';
import { AdminRoutingModule } from './admin-routing.module';

import { IndexComponent } from './pages/index/index.component';

import { DashboardComponent } from './pages/dashboard/pages/dashboard.component';
import { TopServiceCreateComponent } from './pages/dashboard/components/top-service-create/top-service-create.component';

import { ServiceCatalogComponent } from './pages/service-catalog/pages/service-catalog/service-catalog.component';
import { DialogEditIconComponent } from './pages/service-catalog/dialogs/dialog-edit-icon/dialog-edit-icon.component';
import { DialogEditImageComponent } from './pages/service-catalog/dialogs/dialog-edit-image/dialog-edit-image.component';
import { SelfDiagnosisDetailsComponent } from './pages/service-catalog/components/self-diagnosis-details/self-diagnosis-details.component';
import { DialogUpdateCategoryComponent } from './pages/service-catalog/dialogs/dialog-update-category/dialog-update-category.component';
import { EditIconComponent } from './pages/service-catalog/components/edit-icon/edit-icon.component';
import { EditImageComponent } from './pages/service-catalog/components/edit-image/edit-image.component';
import { ServiceCatalogCategoriesComponent } from './pages/service-catalog/pages/service-catalog-categories/service-catalog-categories.component';
import { ServiceCatalogMasterCategoriesComponent } from './pages/service-catalog/pages/service-catalog-master-categories/service-catalog-master-categories.component';
import { AdminPanelMenuComponent } from './components/admin-panel-menu/admin-panel-menu.component';
import { SelfDiagnosisComponent } from './pages/service-catalog/pages/self-diagnosis/self-diagnosis.component';

import { ProblemsComponent } from './pages/problems/problems.component';
import { ProblemComponent } from './pages/problem/problem.component';
import { ServiceCatalogCategoriesDetailsComponent } from './pages/service-catalog/components/service-catalog-categories-details/service-catalog-categories-details.component';
import { ServiceCatalogDetailsComponent } from './pages/service-catalog/components/service-catalog-details/service-catalog-details.component';
import { NotificationTemplatesComponent } from './pages/notification-templates/pages/notification-templates/notification-templates.component';
import { NotificationTemplateDetailsComponent } from './pages/notification-templates/components/notification-template-details/notification-template-details.component';
import { NotificationTemplateKeyWordsDetailsComponent } from './pages/notification-templates/components/notification-template-key-words-details/notification-template-key-words-details.component';

@NgModule({
  imports: [CommonModule, TranslateModule, AdminRoutingModule, SharedModule, DevExpressModule],
  declarations: [
    IndexComponent,

    DashboardComponent,
    TopServiceCreateComponent,

    EditIconComponent,
    EditImageComponent,
    AdminPanelMenuComponent,

    ServiceCatalogComponent,
    ServiceCatalogDetailsComponent,

    ServiceCatalogCategoriesComponent,
    ServiceCatalogCategoriesDetailsComponent,

    ServiceCatalogMasterCategoriesComponent,

    SelfDiagnosisComponent,
    SelfDiagnosisDetailsComponent,

    DialogEditIconComponent,
    DialogEditImageComponent,
    DialogUpdateCategoryComponent,

    ProblemsComponent,
    ProblemComponent,
    NotificationTemplatesComponent,
    NotificationTemplateDetailsComponent,
    NotificationTemplateKeyWordsDetailsComponent,
  ],
})
export class AdminModule {}
